import React from 'react';
import { Link as LinkS } from 'react-scroll';
import heroimage from '../../images/heroimage.jpg'
import './Herocase.css';
const Herocase = () => {
    return (
        <div className='herocase' style={{
            backgroundImage: `url(${heroimage})`,
            backgroundSize: 'cover', backgroundPosition: 'center center'
        }}>
            <div className='herocase__contents'>
                <div className='herocase__title'>
                    Our mission is to Protect your
                    System and enhance IT services Much more.
                </div>
                <div className='herocase__description'>
                    You can rely on our 24/7 dedicated support
                    that will gladly solve any IT related issue you may have.
                </div>
                <div className='herocase__buttons'>
                    <button className='herocase__button'><LinkS to='about' smooth={true} duration={1000}>Discover More</LinkS></button>
                </div>
            </div>
        </div>
    )
}

export default Herocase
